import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { currencyFormat } from 'utilities/common';

const Table = ({ data }) => {
  if (!data) {
    return (
        <div className="row">
            <div className="empty col-lg-12 truck">
              <div className="truck-wrapper">
                <div className="truck">
                  <div className="truck-container"></div>
                  <div className="glases"></div>
                  <div className="bonet"></div>
                  <div className="base"></div>
                  <div className="base-aux"></div>
                  <div className="wheel-back"></div>
                  <div className="wheel-front"></div>
                  <div className="smoke"></div>
                </div>
              </div>
              <p className="empty-title">Omset Customer not found.</p>
            </div>
        </div>
    )
  }

  return (
    <div className="table-responsive m-0 table-overflow">
      <table
        className="table table-vcenter card-table datatable border-bottom"
        width="100%"
      >
        <thead>
          <tr>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Client
            </th>
            <th
              className="text-end border-end"
              style={{ whiteSpace: 'initial', width: '5%' }}
            >
              Total
            </th>
            {data?.labels?.map((d, i) => (
              <th key={i} className="text-end border-end">
                {d}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="bg-white graph">
          {data?.customers?.map((d, i) => (
            <tr key={`${i}-${i}-${i}`}>
              <td className="border-end">
                <div className="table-col">
                  <div className="text-ellipsis fw-semibold text-uppercase">
                    {d?.customer?.name}
                  </div>
                  <small className="info text-uppercase">
                    {d?.customer?.company_name}
                  </small>
                </div>
              </td>
              <td style={{width: '5%'}} className="border-end text-end">
                {currencyFormat(d?.subtotal)}
              </td>
              {d?.datas?.map((s, ii) => (
                <>
                    <td
                      key={`${i}-${ii}`}
                      className={`text-end border-end`}
                    >
                        <OverlayTrigger
                          key="top"
                          placement="top"
                          overlay={
                            <Tooltip id={`tooltip-top`}>Omset</Tooltip>
                          }
                        >
                          <div>{currencyFormat(s)}</div>
                        </OverlayTrigger>
                    </td>
                </>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;